import { styled } from '@mui/material';

export const FAQ = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const SliderWrap = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));

export const List = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));
